import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import { shiftService } from '../services/shiftService';

const useShift = (currentUser, locationId) => {
  const [currentShift, setCurrentShift] = useState(null);
  const [showOpenShiftModal, setShowOpenShiftModal] = useState(false);
  const [showCloseShiftModal, setShowCloseShiftModal] = useState(false);

  const loadCurrentShift = useCallback(async () => {
    if (!currentUser || !locationId) return;

    try {
      const response = await shiftService.getCurrentShift(currentUser, locationId);
      if (response.success && response.data) {
        setCurrentShift(response.data);

        // Sprawdź czy zmiana jest przeterminowana (z poprzedniego dnia)
        if (response.data.is_expired) {
          // Automatycznie pokaż modal zamknięcia zmiany
          setTimeout(() => {
            toast.error(`UWAGA: Otwarta zmiana z dnia ${response.data.data_zmiany} jest przeterminowana! Musisz ją zamknąć przed rozpoczęciem pracy.`);
            setShowCloseShiftModal(true);
          }, 500);
        }
      } else {
        setCurrentShift(null);
      }
    } catch (err) {
      console.error('Błąd ładowania aktualnej zmiany:', err);
      setCurrentShift(null);
    }
  }, [currentUser, locationId]);

  const openShift = useCallback(() => {
    setShowOpenShiftModal(true);
  }, []);

  const closeShift = useCallback(() => {
    setShowCloseShiftModal(true);
  }, []);

  const handleShiftOpened = useCallback(async () => {
    try {
      const response = await shiftService.getCurrentShift(currentUser, locationId);
      if (response.success) {
        setCurrentShift(response.data);
      }
      toast.success('Zmiana zostala otwarta pomyslnie!');
    } catch (err) {
      console.error('Blad ladowania zmiany:', err);
      toast.error('Blad ladowania zmiany: ' + err.message);
    }
  }, [currentUser, locationId]);

  const handleShiftClosed = useCallback(() => {
    setCurrentShift(null);
    toast.success('Zmiana zostala zamknieta pomyslnie z pelnym raportem!');
  }, []);

  return {
    currentShift,
    setCurrentShift,
    showOpenShiftModal,
    setShowOpenShiftModal,
    showCloseShiftModal,
    setShowCloseShiftModal,
    loadCurrentShift,
    openShift,
    closeShift,
    handleShiftOpened,
    handleShiftClosed
  };
};

export default useShift;
